import React from 'react';
import unimedLogo from '../../assets/images/logo-unimed-campinas.svg';
import { useAccessibility } from '../../Store/contexts/AccessibilityContext';


const InformeWelcome: React.FC = () => {

  const { textStyleAccessibility, contrastMode } = useAccessibility();

  return (
    <div className='width-100'>
      {
        contrastMode ?
          <h1 style={textStyleAccessibility} className='login-unimed-logo'>Unimed<br />Campinas</h1>
          :
          <img src={unimedLogo} width={'227px'} height={'85px'} alt="Logo Unimed" className='login-unimed-logo' />
      }
      <div className='container-login-painel-left' style={{maxWidth: '390px'}}>
        <span style={textStyleAccessibility} className='login-painel-left-title margin-bottom line-height-title'>Comprovante de Pagamentos - Unimed Campinas</span>
        <span style={textStyleAccessibility} className='login-painel-left-subtitle margin-bottom'><b>Bem-vindo(a)!</b></span>
        <span style={textStyleAccessibility} className='login-text'>Informe seus dados para acessar seus comprovantes de pagamento.</span>
      </div>
    </div>
  );
};

export default InformeWelcome;
